import axios from "axios";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/';

export default {
  async login(user) {
    try {
      const response = await axios.post(API_URL + "login", user);
      
      if (response.data.access_token) {
        const token = response.data.access_token;
        
        // Guardar el token inmediatamente
        localStorage.setItem("auth_token", token);
        console.log('Token guardado en localStorage:', token.substring(0, 20) + '...');
        
        // Verificar si la respuesta ya incluye datos del usuario
        if (response.data.user) {
          console.log('Datos del usuario incluidos en la respuesta del login');
          
          // Guardar información del usuario
          const userData = response.data.user;
          localStorage.setItem("userF", JSON.stringify(userData));
          
          // Retornar datos estructurados para el store
          return {
            data: {
              user: userData,
              token: token
            }
          };
        } else {
          // Fallback: intentar obtener usuario desde /me
          console.log('Intentando obtener información del usuario desde /me...');
          
          try {
            const userResponse = await axios.get(API_URL + "me", {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });

            console.log('Información del usuario obtenida exitosamente');
            console.log('[auth.service] Respuesta completa de /me:', userResponse.data);
            console.log('[auth.service] pgsql_id en respuesta:', userResponse.data.pgsql_id);

            // Guardar información del usuario
            const userData = userResponse.data;
            console.log('[auth.service] userData a guardar:', userData);
            localStorage.setItem("userF", JSON.stringify(userData));
            console.log('[auth.service] userData guardado en localStorage:', JSON.parse(localStorage.getItem('userF')));
            
            // Retornar datos estructurados para el store
            return {
              data: {
                user: userData,
                token: token
              }
            };
          } catch (userError) {
            console.warn('Error getting user info after login:', userError.message);
            
            // Mantener el token guardado aunque no obtengamos la info del usuario inmediatamente
            return {
              data: {
                user: null,
                token: token
              }
            };
          }
        }
      }
      
      return response;
    } catch (error) {
      // Solo limpiar localStorage si el login falló completamente
      if (!error.config || !error.config.url.includes('/me')) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("userF");
      }
      throw error;
    }
  },

  async logout() {
    try {
      const token = localStorage.getItem("auth_token");
      if (token) {
        await axios.post(API_URL + "logout", {}, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      }
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      // Eliminar ambos items del localStorage
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userF");
    }
  },

  async register(user) {
    try {
      const response = await axios.post(API_URL + "register", user);
      
      if (response.data.access_token) {
        const token = response.data.access_token;
        
        // Guardar el token inmediatamente
        localStorage.setItem("auth_token", token);
        
        // Obtener información del usuario con el token recién guardado
        try {
          const userResponse = await axios.get(API_URL + "me", {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          
          // Guardar información del usuario
          const userData = userResponse.data;
          localStorage.setItem("userF", JSON.stringify(userData));
          
          // Retornar datos estructurados para el store
          return {
            data: {
              user: userData,
              token: token
            }
          };
        } catch (userError) {
          console.error('Error getting user info after register:', userError);
          
          // Si falla obtener info del usuario, mantener el registro pero sin datos de usuario
          localStorage.setItem("userF", JSON.stringify(token)); // Compatibilidad
          
          return {
            data: {
              user: null,
              token: token
            }
          };
        }
      }
      
      return response;
    } catch (error) {
      // Limpiar cualquier token que pueda haberse guardado
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userF");
      throw error;
    }
  },

  // Método para obtener el usuario actual
  async getCurrentUser() {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      console.error('[auth.service] getCurrentUser - No token found');
      throw new Error('No token found');
    }

    console.log('[auth.service] getCurrentUser - Haciendo petición a /me con token:', token.substring(0, 20) + '...');

    const response = await axios.get(API_URL + "me", {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    console.log('[auth.service] getCurrentUser - Respuesta recibida:', {
      status: response.status,
      hasData: !!response.data,
      id: response.data?.id,
      pgsql_id: response.data?.pgsql_id,
      name: response.data?.name
    });

    return response;
  },

  // Nuevo método para obtener permisos del usuario
  async getUserPermissions() {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      throw new Error('No token found');
    }
    
    try {
      const response = await axios.get(API_URL + "me/permissions", {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Verificar que la respuesta tenga el formato esperado
      if (response.data && response.data.data) {
        return response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        // Si los permisos vienen directamente en data
        return response.data;
      } else {
        console.warn('Formato de respuesta de permisos inesperado:', response.data);
        return {};
      }
    } catch (error) {
      console.error('Error getting user permissions:', error);
      
      // Si es error 401 o 403, el token es inválido
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("userF");
      }
      
      throw error;
    }
  },

  // Método para actualizar el perfil del usuario
  async updateProfile(profileData) {
    const token = localStorage.getItem("auth_token");
    const response = await axios.put(API_URL + "me", profileData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response;
  },

  // Método para refrescar la información del usuario
  async refreshUser() {
    try {
      console.log('[auth.service] refreshUser - Obteniendo datos del usuario desde /me');
      const userResponse = await this.getCurrentUser();
      const userData = userResponse.data;

      console.log('[auth.service] refreshUser - Datos obtenidos:', {
        id: userData.id,
        pgsql_id: userData.pgsql_id,
        name: userData.name,
        email: userData.email,
        hasId: !!userData.id,
        hasPgsqlId: !!userData.pgsql_id
      });

      localStorage.setItem("userF", JSON.stringify(userData));

      console.log('[auth.service] refreshUser - Datos guardados en localStorage');
      console.log('[auth.service] refreshUser - Verificando localStorage:',
        JSON.parse(localStorage.getItem('userF'))
      );

      return userData;
    } catch (error) {
      console.error('[auth.service] refreshUser - Error:', error);
      throw error;
    }
  },

  // Método para verificar si el token es válido
  async validateToken() {
    try {
      const token = localStorage.getItem("auth_token");
      if (!token) {
        return false;
      }
      
      const response = await axios.get(API_URL + "me", {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return response.status === 200;
    } catch (error) {
      return false;
    }
  },

  // Método para verificar si el usuario tiene un permiso específico
  async hasPermission(permission) {
    try {
      const permissions = await this.getUserPermissions();
      return permissions[permission] === true;
    } catch (error) {
      console.error('Error checking permission:', error);
      return false;
    }
  },

  // Método para verificar acceso a módulos específicos
  async hasModuleAccess(moduleId) {
    try {
      const permissions = await this.getUserPermissions();
      return permissions[moduleId] === true;
    } catch (error) {
      console.error('Error checking module access:', error);
      return false;
    }
  },

  // Método para obtener el pgsql_id del usuario (fallback si no está en /me)
  async getPgsqlId() {
    try {
      const token = localStorage.getItem("auth_token");
      if (!token) {
        console.error('[auth.service] getPgsqlId - No token found');
        return null;
      }

      console.log('[auth.service] getPgsqlId - Intentando obtener pgsql_id desde el backend');

      // Intentar desde el endpoint /me primero
      const userResponse = await this.getCurrentUser();
      if (userResponse.data.pgsql_id) {
        console.log('[auth.service] getPgsqlId - pgsql_id encontrado en /me:', userResponse.data.pgsql_id);

        // Actualizar localStorage con el pgsql_id
        const userF = localStorage.getItem('userF');
        if (userF) {
          const userData = JSON.parse(userF);
          userData.pgsql_id = userResponse.data.pgsql_id;
          localStorage.setItem('userF', JSON.stringify(userData));
          console.log('[auth.service] getPgsqlId - pgsql_id actualizado en localStorage');
        }

        return userResponse.data.pgsql_id;
      }

      console.warn('[auth.service] getPgsqlId - pgsql_id no disponible en /me');
      return null;
    } catch (error) {
      console.error('[auth.service] getPgsqlId - Error:', error);
      return null;
    }
  }
};